import React from 'react';
import youCrmLogo from '../../assets/youcrm.svg';

interface LogoProps {
  className?: string;
  showCompanyName?: boolean;
  variant?: 'default' | 'modern' | 'compact';
}

const Logo: React.FC<LogoProps> = ({ 
  className, 
  showCompanyName = true, 
  variant = 'modern' 
}) => {
  if (variant === 'modern') {
    return (
      <div className="flex flex-col items-center">
        <div className="relative flex items-center justify-center">
          <div className="absolute -inset-1 bg-gradient-to-r from-primary-400 to-primary-600 rounded-lg blur opacity-30"></div>
          <img 
            src={youCrmLogo} 
            alt="YouCRM Logo" 
            className={`relative ${className} transition-all duration-300`} 
          />
        </div>
        {showCompanyName && (
          <div className="mt-2 mb-2 relative inline-flex group">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-primary-500 to-primary-600 rounded-md blur opacity-30 group-hover:opacity-70 transition duration-1000 group-hover:duration-200"></div>
            <span className="relative px-3 py-0.5 text-xs font-medium bg-white text-primary-700 rounded-md shadow-sm border border-primary-100 group-hover:text-primary-800 transition-colors">
              Energia Info Kft.
            </span>
          </div>
        )}
      </div>
    );
  }
  
  if (variant === 'compact') {
    return (
      <div className="flex items-center space-x-2">
        <img 
          src={youCrmLogo} 
          alt="YouCRM Logo" 
          className={`${className} max-h-8`} 
        />
        {showCompanyName && (
          <span className="text-xs font-semibold text-primary-700 bg-primary-50 px-2 py-0.5 rounded-md">
            Energia Info
          </span>
        )}
      </div>
    );
  }
  
  // Default variant
  return (
    <div className="flex flex-col items-center pt-1">
      <img 
        src={youCrmLogo} 
        alt="YouCRM Logo" 
        className={className} 
      />
      {showCompanyName && (
        <span className="mt-1 px-3 py-0.5 text-xs font-medium bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-md shadow-sm">
          Energia Info Kft.
        </span>
      )}
    </div>
  );
};

export default Logo; 